/**
 * List Schema of Rastreamento
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'

/* TODO: review generated schema */
export class ListRastreamentoSchema extends Schema {
  readonly name = 'ListRastreamento'

  readonly fieldSet: FieldSet<Rastreamento> = {
    idRastreamentoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    placa: (): FieldComponent => ({
      is: Component.Render,
    }),
    codigoViagem: (): FieldComponent => ({
      is: Component.Render,
    }),
    latitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    longitude: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataUltimaPosicao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataUltimaPosicao),
      },
    }),
    endereco: (): FieldComponent => ({
      is: Component.Render,
    }),
    numeroParadas: (): FieldComponent => ({
      is: Component.Render,
    }),
    codigoRastreioVeiculo: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
